import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../styles/login.scss";
import i18n from "../i18n";
import { useTranslation } from "react-i18next";

const LoginPage = () => {
  const url = process.env.REACT_APP_URL;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(`${url}/audit/login`, {
        ...formData,
      });

      const { token, user } = response.data;

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      navigate("/");
    } catch (err) {
      console.log(err);
      const msg =
        err.response?.data?.message || "No entry: Invalid credentials";
      setError(msg);

      if (err.status === 403) {
        navigate("/first-login");
      }
    }
  };

  return (
    <div className="login-container">
      <form className="form" onSubmit={handleSubmit}>
        <div className="language-switch">
          <button type="button" onClick={() => i18n.changeLanguage("en")}>
            🇬🇧
          </button>
          <button type="button" onClick={() => i18n.changeLanguage("es")}>
            🇪🇸
          </button>
        </div>

        <h2 className="title">{t("welcome") || "Welcome Back"}</h2>

        <label className="label" htmlFor="email">
          {t("email") || "Email"}
          <input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </label>

        <label className="label" htmlFor="password">
          {t("password") || "Password"}
          <input
            id="password"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </label>

        {error && <div className="error">{error}</div>}

        <button className="button" type="submit">
          {t("signin") || "Sign In"}
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
